export const CreateExpenseSvg = ({className}) => {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 3V22L6 20L9 22L12 20L13.3 20.86C13.1 20.28 13 19.65 13 19C13.0006 18.0402 13.2313 17.0946 13.6727 16.2424C14.114 15.3901 14.7532 14.6561 15.5367 14.1018C16.3202 13.5474 17.2252 13.189 18.1757 13.0565C19.1263 12.9239 20.0948 13.0211 21 13.34V3H3ZM17 7V9H7V7H17ZM15 11V13H7V11H15ZM18 15V18H15V20H18V23H20V20H23V18H20V15H18Z" fill="black"/>
    </svg>    
  )
}
